import React, { useReducer, useState } from "react";
import "./terminal.scss";
import { Add, CancelRounded, CheckCircle, Print } from "@mui/icons-material";
import SearchBar from "../../../component/searchBar/Search.tsx";
import { Tooltip } from "@mui/material";
import Delete from "../../../component/dialog/delete/Delete.tsx";
import NewTerminal from "./NewTerminal.tsx";
import UpdateTerminal from "./UpdateTerminal.tsx";
import { requestType, terminalType } from "../../../types/GlobalType.ts";
import { accountService } from "../../../_services/accountServices.js";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import toast from "react-hot-toast";
import MyLoading from "../../../component/loader/MyLoading.tsx";
import { orderBy } from "lodash";
import { useNavigate } from "react-router-dom";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";

const Terminal = () => {
  const [dataTerminal, setDataTerminal] = useState<terminalType[]>([]);
  const [singleTerminalData, setsingleTerminalData] = useState<terminalType>();

  const [openArchiveTerminal, setopenArchiveTerminal] =
    React.useState<Boolean>(false);
  const [openActivateTerminal, setopenActivateTerminal] =
    React.useState<Boolean>(false);
  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);
  const [openAddTerminal, setopenAddTerminal] = React.useState<boolean>(false);
  const [openUpdateTerminal, setopenUpdateTerminal] =
    React.useState<boolean>(false);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const navigate = useNavigate();

  const [itemId, setItemId] = useState<string | number>();
  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);
  const [searchValue, setSearchValue] = useState("");

  const fetchAllTerminaux = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    try {
      const response = await API_CONFIG.TERMINAL.getAll(token);
      setDataTerminal(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleActivateTerminal = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.TERMINAL.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivateTerminal(false);
      dispatchReload();
      toast.success("Terminal activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveTerminal = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    try {
      await API_CONFIG.TERMINAL.desactive(id, token);
      setLoadingDeleteBtn(false);
      setopenArchiveTerminal(false);
      dispatchReload();
      toast.success("Terminal archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  let sortedData: terminalType[] = [];
  if (dataTerminal.length > 0) {
    sortedData = orderBy(
      dataTerminal,
      ["terminal_status", "terminal_created_at"],
      ["desc", "desc"]
    );
  }

  React.useEffect(() => {
    fetchAllTerminaux();
  }, [stateReload]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="topTerminal">
          {state.isLoading && <MyLoading isLoading={state.isLoading} />}
          <div className="List_personnel">
            <div className="headerPers">
              <h2 className="card-title">Terminaux</h2>
              <div className="input-container">
                <SearchBar setSearchValue={setSearchValue} />
                <button className="add_button_pers">
                  <Tooltip title="Imprimer">
                    <Print className="ico" />
                  </Tooltip>
                </button>
                <button className="add_button_pers">
                  <Tooltip title="Ajouter">
                    <Add
                      className="ico"
                      onClick={() => setopenAddTerminal(true)}
                    />
                  </Tooltip>
                </button>
              </div>
            </div>
            <div className="table_component" role="region">
              <table>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Terminal Désignation</th>
                    <th>Numéro ID</th>
                    <th className="headerSection">Status</th>
                    <th className="actionHeader">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData
                    .filter((value) =>
                      value.terminal_designation
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
                    )
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.terminal_designation}</td>
                          <td>{item.terminal_uid}</td>
                          <td className="statusSection">
                            <span>
                              {item.terminal_status ? (
                                <Tooltip title="Activé" placement="left">
                                  <CheckCircle
                                    style={{
                                      color: "#28a745",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Tooltip>
                              ) : (
                                <Tooltip title="Archivé" placement="left">
                                  <CancelRounded
                                    style={{
                                      color: "#7f1d18",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </span>
                          </td>{" "}
                          <td className="actionSection">
                            <span
                              className="edit"
                              onClick={() => {
                                setsingleTerminalData(item);
                                setopenUpdateTerminal(true);
                              }}
                            >
                              Edit
                            </span>
                            {item.terminal_status ? (
                              <span
                                className="archive"
                                onClick={() => {
                                  setItemId(item.terminal_id);
                                  setopenArchiveTerminal(true);
                                }}
                              >
                                Archiver
                              </span>
                            ) : (
                              <span
                                className="archive"
                                onClick={() => {
                                  setItemId(item.terminal_id);
                                  setopenActivateTerminal(true);
                                }}
                              >
                                Activer
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {openAddTerminal && (
        <NewTerminal
          setOpen={setopenAddTerminal}
          dispatchReload={dispatchReload}
        />
      )}
      {openUpdateTerminal && (
        <UpdateTerminal
          setOpen={setopenUpdateTerminal}
          dispatchReload={dispatchReload}
          data={singleTerminalData}
        />
      )}

      {openActivateTerminal && (
        <Delete
          setOpen={setopenActivateTerminal}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce terminal?"}
          handleDelete={handleActivateTerminal}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveTerminal && (
        <Delete
          setOpen={setopenArchiveTerminal}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce terminal?"}
          handleDelete={handleArchiveTerminal}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default Terminal;
